import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'pontoContrato'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos/${id}/pontos_contrato`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/pontos_contrato/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingPontoContratoSuccess(resource))
  return Promise.resolve(resource)
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_PONTO_CONTRATO_SUCCESS = 'LOADING_PONTO_CONTRATO_SUCCESS'
export function loadingPontoContratoSuccess(pontoContrato) {
  return {
    type: LOADING_PONTO_CONTRATO_SUCCESS,
    pontoContrato,
  }
}

export const DESTROYING_PONTO_CONTRATO_SUCCESS =
  'DESTROYING_PONTO_CONTRATO_SUCCESS'
export function destroyingPontoContratoSuccess(pontoContratoId) {
  return {
    type: DESTROYING_PONTO_CONTRATO_SUCCESS,
    pontoContratoId,
  }
}

export function fetchMultiplePontoContrato(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const pontoContrato = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_PONTO_CONTRATO_SUCCESS: {
      const { pontoContrato: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_PONTO_CONTRATO_SUCCESS:
      return state.delete(action.pontoContratoId.toString())

    default:
      return state
  }
}

export default pontoContrato
